module.exports = __webpack_public_path__ + "static/media/dumagueteSeal.c50b7d65.png";